module.exports = __webpack_public_path__ + "static/media/star_326.ee12c7eb.png";